import { defineComponent as r, computed as l, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as n, createStaticVNode as p } from "vue";
const v = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "01f8e8cf-4446-40b3-9b74-719d7a9589d0" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#01f8e8cf-4446-40b3-9b74-719d7a9589d0)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><circle cx="367.3" cy="144.7" r="44.5" fill="#6da544"></circle><path fill="#d80027" d="M289.4 133.5h155.8l.1 29-76.9 79.7-79.1-79.7z"></path><path fill="#496e2d" d="M445.2 256zm-155.8 0z"></path><path fill="#ffda44" d="M289.4 300.5V345h23.4a77.6 77.6 0 0 0 109 0h23.4v-44.5z"></path><path fill="#338af3" d="M289.3 193.7v31.2l8 16.6-7.9 14.5c.1 59.6 77.9 78 77.9 78s78-18.4 78-78l-7.7-13.2 7.7-18v-31.1l-78-10.2z"></path><path fill="#eee" d="M367.3 224.9c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8V256c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8zm0-62.4c-19.5 0-19.5 17.8-39 17.8s-19.4-17.8-39-17.8v31.2c19.7 0 19.6 17.8 39 17.8s19.5-17.8 39-17.8 19.5 17.8 39 17.8 19.4-17.8 39-17.8v-31.2c-19.6 0-19.6 17.8-39 17.8-19.5 0-19.5-17.8-39-17.8z"></path>', 9), g = { fill: "none" }, V = ["r"], M = /* @__PURE__ */ r({
  __name: "ky",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), h = l(() => 256 + e.strokeWidth / 2);
    return (z, x) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (c(), s("title", k, d(e.flagName), 1)) : f("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: h.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, v));
  }
});
export {
  M as default
};
//# sourceMappingURL=ky-e2229c9a.js.map
